webpackJsonp([2],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_03_bg.png?d80ae75907af52625a259209cdd53c94";

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-margin-bottom"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("集体学习")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid content-style"
  }, [_c('div', {
    staticClass: "jieshao_ul"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/44.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2026年4月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("腾讯Work Buddy智能体应用分享")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/43.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2026年3月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("OPEN CLAW学习与应用")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/42.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年12月27日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI工具挑战赛2.0")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/41.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年11月30日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI应用实战培训")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/40.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年10月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI工具挑战赛")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/39.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年9月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI应用学习分享")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/38.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年9月1日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("南站喜街乐跑赛")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/37.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年7月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("亚运城喜街参观考察"), _c('br'), _vm._v("《关于企业与个人成长的思考》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/36.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年5月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("1906科技园扬韬广场参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/35.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年4月27日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("三七互娱全球总部参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/34.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年3月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("东谷中心商业参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/33.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年2月5日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("2025开年登山活动")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/32.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年11月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《价值主张Ⅱ》内部研讨会")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/31.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年10月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《价值主张》内部研讨会")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/30.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年9月21日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("2024南站喜街乐跑赛")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/29.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年8月24日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("深化军队文化建设"), _c('br'), _vm._v("《我们的时代，我们的奋斗》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/28.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年7月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("中国经济形势分析")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/27.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年6月29日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《TED》演讲视频合集学习与讨论")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/26.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年5月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("保利鱼珠时光商业参观考察"), _c('br'), _vm._v("美林M·LIVE天地商业参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/25.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年4月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("思维导图与PPT应用大比武")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/24.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年3月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("PPT与思维导图深化运用")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/23.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年2月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("黄埔军校旧址参观学习")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/22.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年12月16日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("业务本领学习与复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/21.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年11月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("业务本领学习与复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/20.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年10月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("业务本领学习与复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/19.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年9月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("熙二戈壁110公里感悟分享")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/18.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年8月16日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("香港商业街区走访学习")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/17.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年7月29日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("亚运城喜街项目历程分享及实地走访")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/16.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年7月1日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《营销平台研究与探索》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/01.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年5月27日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("ChatGPT实操")]), _vm._v(" "), _c('p', [_vm._v("《对标企业商业模式研究》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/02.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年4月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《所有人都能玩转的ChatGPT》")]), _vm._v(" "), _c('p', [_vm._v("《我国发展商业地产REITS模式研究》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/03.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年3月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《人工智能》")]), _vm._v(" "), _c('p', [_vm._v("《房地产投资信托基金》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/04.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年2月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("同熙商业3.0模式复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/05.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年12月31日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("大夫山户外拓展学习会")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/06.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年11月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《海外市场商业地产现状及动向》")]), _vm._v(" "), _c('p', [_vm._v("《数字化建设案例或实践学习》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/07.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年10月29日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《深化军队文化建设》系列")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/08.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年9月18日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("“熙一”十人分享感悟")]), _vm._v(" "), _c('p', [_vm._v("《一人一厨一狗》华为系列故事学习")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/09.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年8月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《向军队学习执行力》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/10.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年7月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《苏世民：我的经验与教训》")]), _vm._v(" "), _c('p', [_vm._v("《商业运营学习分享》")]), _vm._v(" "), _c('p', [_vm._v("《公司法》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/11.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年6月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《商业地产的投资要点与难点》")]), _vm._v(" "), _c('p', [_vm._v("《商业地产的营销要点与难点》")]), _vm._v(" "), _c('p', [_vm._v("《商业地产的商管运营要点与难点》")]), _vm._v(" "), _c('p', [_vm._v("《我在世界五百强的工作经验》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/12.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年5月21日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《建立学习型团队》")]), _vm._v(" "), _c('p', [_vm._v("《活到老学到老》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/13.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年4月16日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《访问美军院校见闻》")]), _vm._v(" "), _c('p', [_vm._v("《康熙五十六年谕旨》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/14.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年3月19日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《黄奇帆独家解读房地产》")]), _vm._v(" "), _c('p', [_vm._v("《灰度法则打造华为常胜铁军》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/15.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年2月19日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《华为如何锻造打胜仗的组织》")]), _vm._v(" "), _c('p', [_vm._v("《华为向军队学习了什么》")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0",
      "margin": "0"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0",
      "margin": "0"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0",
      "margin": "0"
    }
  })])])])])
}]}

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(74);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(7)("1db7b5bc", content, true);

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

var Vue = __webpack_require__(3);
var VueI18n = __webpack_require__(0);
Vue.use(VueI18n);

//import nls
var nls = __webpack_require__(4);
var defaultLocale = localStorage.getItem("defaultLocale");
if (defaultLocale == null) {
    defaultLocale = nls.defaultLocale;
}
var i18n = new VueI18n({
    locale: defaultLocale, // set locale
    messages : nls.text, // set locale messages
});

// 获取组件引用
// var testC = require('./components/App.vue');
var header_comp = __webpack_require__(2);
var body_comp = __webpack_require__(23);
var footer_comp = __webpack_require__(1);

window.vm = new Vue({
    i18n : i18n,  // VueI18n 插件
    el:"#app",
    components: {
        header_comp: header_comp,
        body_comp: body_comp,
        footer_comp: footer_comp
    }
});

// $(document).ready(function () {
//     $('#modal_video').on('hide.bs.modal', function () {
//         document.getElementById('video').pause();
//     });
// });


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(110),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


module.exports = {
    computed: {
        pan_height_line1: function () {
            return {
                pan_height_line1_zh: this.$i18n.locale != 'en_US',
                pan_height_line1_en: this.$i18n.locale == 'en_US'
            };
        },
        pan_height_line2: function () {
            return {
                pan_height_line2_zh: this.$i18n.locale != 'en_US',
                pan_height_line2_en: this.$i18n.locale == 'en_US'
            };
        }
    },
    mounted: function () {

        $('#fundCert').viewer({
            scalable: false,
            navbar: false,
            title: false,
            toolbar: false,
            url: 'data-original'
        });
        window.pageTitle = {
            en_US: this.$i18n.messages.en_US.page_title_culture,
            zh_HK: this.$i18n.messages.zh_HK.page_title_culture,
            zh_CN: this.$i18n.messages.zh_CN.page_title_culture
        };
        window.setTitle(window.pageTitle[this.$i18n.locale]);
    }

};

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "body,html{position:relative;height:100%;font-size:12px}.swiper-container{width:100%;height:100%}body:after{background-image:url(" + __webpack_require__(94) + ");background-repeat:no-repeat;background-size:cover}.pan_height_line1_zh{height:auto}@media (min-width:992px){.pan_height_line1_zh{height:360px}}@media (min-width:1200px){.pan_height_line1_zh{height:340px}}.pan_height_line1_en{height:auto}@media (min-width:992px){.pan_height_line1_en{height:360px}}@media (min-width:1200px){.pan_height_line1_en{height:340px}}.pan_height_line2_zh{height:auto}@media (min-width:992px){.pan_height_line2_zh{height:220px}}@media (min-width:1200px){.pan_height_line2_zh{height:220px}}.pan_height_line2_en{height:auto}@media (min-width:992px){.pan_height_line2_en{height:220px}}@media (min-width:1200px){.pan_height_line2_en{height:220px}}.container-margin-bottom{margin-bottom:10px}@media (min-width:768px){.container-margin-bottom{margin-bottom:60px}}.pan-num{text-align:center;font-size:80px;color:#d3a571;padding-left:20px;padding-top:25px}@media (min-width:768px){.pan-num{font-size:144px;padding-top:0}}.pan-num-size{width:80px}@media (min-width:768px){.pan-num-size{width:130px}}@media (min-width:992px){.pan-num-size{width:130px}}@media (min-width:1200px){.pan-num-size{width:150px}}.pan-01-wrapper{padding:0 0 30px}@media (min-width:768px){.pan-01-wrapper{padding:0 0 30px}}@media (min-width:992px){.pan-01-wrapper{padding:0 45px 30px 0}}@media (min-width:1200px){.pan-01-wrapper{padding:0 45px 30px 0}}.pan-01{background:#fff;background-image:url(" + __webpack_require__(8) + ");background-position-x:right;background-position-y:top;background-repeat:no-repeat;background-size:20% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-01{background-size:15% auto}}@media (min-width:992px){.pan-01{background-size:30% auto}}.pan-01b-size{width:70%}@media (min-width:768px){.pan-01b-size{width:80%}}@media (min-width:992px){.pan-01b-size{width:70%}}.pan-01-detail-size{width:85%}@media (min-width:768px){.pan-01-detail-size{width:85%}}@media (min-width:992px){.pan-01-detail-size{width:70%}}.pan-02-wrapper{padding:0 0 30px}.pan-02{background:#fff;background-image:url(" + __webpack_require__(9) + ");background-position-x:right;background-position-y:bottom;background-repeat:no-repeat;background-size:20% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-02{background-size:20% auto}}@media (min-width:992px){.pan-02{background-size:28%}}@media (min-width:1200px){.pan-02{background-size:auto}}.pan-02b-size{width:70%}@media (min-width:768px){.pan-02b-size{width:80%}}@media (min-width:992px){.pan-02b-size{width:65%}}@media (min-width:1200px){.pan-02b-size{width:60%}}.pan-02-detail-size{width:85%}@media (min-width:768px){.pan-02-detail-size{width:80%}}@media (min-width:992px){.pan-02-detail-size{width:68%}}@media (min-width:1200px){.pan-02-detail-size{width:65%}}.pan-03-wrapper{padding:0 0 30px}@media (min-width:768px){.pan-03-wrapper{padding:0 0 30px}}@media (min-width:992px){.pan-03-wrapper{padding:0 0 30px}}@media (min-width:1200px){.pan-03-wrapper{padding:0 0 30px}}.pan-03{background:#fff;background-image:url(" + __webpack_require__(10) + ");background-position-x:right;background-position-y:bottom;background-repeat:no-repeat;background-size:25% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-03{background-size:28% auto}}@media (min-width:992px){.pan-03{background-size:31% auto}}@media (min-width:1200px){.pan-03{background-size:33% auto}}.pan-03b-size{width:70%}@media (min-width:768px){.pan-03b-size{width:75%}}@media (min-width:992px){.pan-03b-size{width:75%}}@media (min-width:1200px){.pan-03b-size{width:80%}}.pan-03-detail-size{width:80%}@media (min-width:768px){.pan-03-detail-size{width:70%}}@media (min-width:992px){.pan-03-detail-size{width:70%}}@media (min-width:1200px){.pan-03-detail-size{width:65%}}.pan-04-wrapper{padding:0 0 30px}.pan-04{background:RGBA(0,0,0,.5);box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.content-style{background-color:#fff;margin:0;padding:20px 0}@media (min-width:768px){.content-style{background-color:#fff;margin:0 20px 80px;padding:20px 25px}}.item-padding{height:893px;padding:0}@media (min-width:768px){.item-padding{padding:0 25px}}.jieshao_ul ul{display:flex;flex-wrap:wrap;justify-content:space-between;padding:0;margin:0 20px}.jieshao_ul li{width:31%;padding-bottom:20px;margin-bottom:30px;background:#fff;box-shadow:0 2px 4px rgb(0 0 0/50%);text-align:center;list-style-type:none}.jieshao_ul li img{width:100%;height:240px;object-fit:cover}.jieshao_ul li h3{margin:20px 0 10px;color:#4a4a4a;font-size:22px;font-weight:700;text-align:center}.jieshao_ul li p{margin:0 10px;font-size:16px;color:#9b9b9b;line-height:24px}@media (max-width:992px){.jieshao_ul li{width:100%}.tx-page-title{margin-left:0;margin-right:0}}", ""]);

// exports


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_01_bg.png?3ef0485f5999dcbf2922507024d4622e";

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_02_bg.png?b7c3375f8da4b407281b6eca62a5efd4";

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/index_bg_03.jpg?60439a1c43b97a0695d3397a45c3a731";

/***/ })

},[156]);


// WEBPACK FOOTER //
// js/culture_xx.bundle.js?19064ebf3f55795889cc